import { memo } from 'react';

export const prefix = "entity.";

export default memo(({name}) => `${prefix}${name}`);